import reducre from './reducer'
import globalSagas  from './sagas'
import * as globalActions from './actionCreators'
import * as globalConst from './actionTypes'
import systemChartsSaga  from '../components/SystemCharts/store/saga'
import deviceSearchBoxSaga  from '../components/DeviceSearchBox/store/saga'
import deviceTypeListSaga  from '../components/DeviceTypeList/store/saga'
import visibleSetting from '../components/VisibleSetting/store/saga'
const sagas=[deviceTypeListSaga,deviceSearchBoxSaga,systemChartsSaga,globalSagas,visibleSetting]
export { reducre,sagas,globalActions,globalConst }